const GA4_ID = 'G-EDY52QX0E7';

function getSourcePage() {
  const raw = window.location.pathname.replace(/^\//, '');
  return raw || 'home';
}

export function trackAndNavigate(dest, eventName, extraParams = {}) {
  const go = (url) => { window.location.href = url; };
  const params = { ...extraParams, source_page: getSourcePage() };

  if (typeof window.gtag !== 'function') { go(dest); return; }

  let done = false;
  const safeguard = setTimeout(() => { if (!done) { done = true; go(dest); } }, 500);

  window.gtag('event', eventName, {
    ...params,
    event_callback: () => {
      if (done) return;
      try {
        window.gtag('get', GA4_ID, 'linker', (linkerParam) => {
          clearTimeout(safeguard);
          if (done) return;
          done = true;
          if (typeof linkerParam === 'string' && linkerParam.length > 0) {
            const sep = dest.includes('?') ? '&' : '?';
            go(`${dest}${sep}_gl=${linkerParam}`);
          } else {
            go(dest);
          }
        });
      } catch (_) {
        clearTimeout(safeguard);
        if (!done) { done = true; go(dest); }
      }
    },
  });
}

export function trackEvent(eventName, extraParams = {}) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, { ...extraParams, source_page: getSourcePage() });
}
